import { render, staticRenderFns } from "./CoordenadasClientes.vue?vue&type=template&id=46c21a05&scoped=true&lang=pug"
import script from "./CoordenadasClientes.vue?vue&type=script&lang=js"
export * from "./CoordenadasClientes.vue?vue&type=script&lang=js"
import style0 from "./CoordenadasClientes.vue?vue&type=style&index=0&id=46c21a05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c21a05",
  null
  
)

export default component.exports